import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from "@mui/material";

function ReasonChoice({ setPage, page, data }) {
  const handleClick = (e, id) => {
    page.page === 1
      ? setPage({ ...page, page: 2, motif: data })
      : setPage({
          ...page,
          page: 1,
          motif: null,
          praticien: null,
          date: "",
          valid: false,
        });
  };

  if (!data) return null;
  else
    return page.page === 1 ? (
      <Box width="360px">
        <ListItem>
          <ListItemButton
            value={data.ID}
            onClick={(event) => handleClick(event, data.ID)}
          >
                    <ListItemText className="allow-newline-fix" align="center" primary={<Box><Typography style={{ fontWeight: 'bold', lineHeight: 1 }}>{data.Title}</Typography><Typography>{data.Description}</Typography></Box>} />
          </ListItemButton>
        </ListItem>
        <Divider />
      </Box>
    ) : (
      <CardActionArea
        // container
        style={{ width: "360px" }}
        onClick={(event) => handleClick(event, data.ID)}
      >
        <Card sx={{ "&:hover": { boxShadow: 4 } }}>
          <CardContent
          // style={{
          //   textTransform: "none",
          //   color: "black",
          // }}
                    >
                        <Box><Typography className="allow-newline-fix" align="center" style={{ fontWeight: 'bold', lineHeight: 1 }}>{data.Title}</Typography>
                            <Typography className="allow-newline-fix" align="center">{data.Description}</Typography></Box>
          </CardContent>
        </Card>
      </CardActionArea>
    );
}

export default ReasonChoice;
